import { defineMessages } from 'react-intl';

export const dropdownMessages = defineMessages({
  nothingFound: {
    id: 'fFY/zh',
    defaultMessage: 'No options',
    description: 'Shown in a dropdown when the search query matches no options',
  },
});
